import { render, staticRenderFns } from "./ReleasesListPublic.vue?vue&type=template&id=db681268&scoped=true&"
import script from "./ReleasesListPublic.vue?vue&type=script&lang=js&"
export * from "./ReleasesListPublic.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesListPublic.vue?vue&type=style&index=0&id=db681268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db681268",
  null
  
)

export default component.exports